module.exports = __webpack_public_path__ + "img/title-1.cd062ce3.png";